import React, {useState} from "react";
import Field from "../Field.tsx";


const Password: React.FC = () => {
  const [oldPassword, setOldPassword] = useState<string>("");
  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");

  return (
    <form className="" action="" onSubmit={() => console.log("Submit")}>
      <div className="mb-8 h4 md:mb-6">Password</div>
      <Field
        className="mb-6"
        label="Password"
        placeholder="Password"
        type="password"
        icon="lock"
        value={oldPassword}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => setOldPassword(e.target.value)}
        required
      />
      <Field
        className="mb-6"
        label="New password"
        placeholder="New password"
        note="Minimum 8 characters"
        type="password"
        icon="lock"
        value={newPassword}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => setNewPassword(e.target.value)}
        required
      />
      <Field
        className="mb-6"
        label="Confirm new password"
        placeholder="Confirm new password"
        note="Minimum 8 characters"
        type="password"
        icon="lock"
        value={confirmPassword}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => setConfirmPassword(e.target.value)}
        required
      />
      <button className="btn-purple w-full">Change password</button>
    </form>
  );
};

export default Password;
